import { TLanguageTranslations } from '../utils/types';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const translationsState = atom<TLanguageTranslations | null>({
  key: 'translationsState',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
